import React from 'react'

interface Props {
  name: string
  activeTab: string
}

const TabPanel: React.FC<Props> = (props) => {
  return props.name === props.activeTab
    ? <>
      {props.children}
    </>
    : null
}

export default TabPanel
